export enum DebtorFilterBy {
  NAME = "name",
  PERSON_NO = "personNo",
  ZIP_CODE = "zipCode",
}

export const DEFAULT_DUPLICATE_DEBTOR_FILTERS = [
  DebtorFilterBy.NAME,
  DebtorFilterBy.PERSON_NO,
  DebtorFilterBy.ZIP_CODE,
];

export enum PropertyNames {
  NAME = "name",
  NIN = "nin",
  TYPE = "debtorType",
  GENDER = "gender",
  BIRTH_DATE = "birthdate",
  EMAIL = "email",
  SMS = "sms",
  MOBILE = "mobile",
  TELEPHONE = "telephone",
  WORK = "work",
  COUNTRY_CODE = "countryCode",
  ZIP_CODE = "zipCode",
  ZIP_NAME = "zipName",
  MUNICIPALITY_CODE = "municipalityCode",
  MUNICIPALITY_NAME = "municipalityName",
  ADDRESS_1 = "address1",
  ADDRESS_2 = "address2",
  ADDRESS_3 = "address3",
}

export const DEBTOR_BASIC_INFO = [
  PropertyNames.NAME,
  PropertyNames.NIN,
  PropertyNames.TYPE,
  PropertyNames.GENDER,
  PropertyNames.BIRTH_DATE,
  PropertyNames.EMAIL,
  PropertyNames.SMS,
  PropertyNames.MOBILE,
  PropertyNames.TELEPHONE,
  PropertyNames.WORK,
];

export const DEBTOR_ADDRESS_INFO = [
  PropertyNames.COUNTRY_CODE,
  PropertyNames.ZIP_CODE,
  PropertyNames.ZIP_NAME,
  PropertyNames.MUNICIPALITY_CODE,
  PropertyNames.MUNICIPALITY_NAME,
  PropertyNames.ADDRESS_1,
  PropertyNames.ADDRESS_2,
  PropertyNames.ADDRESS_3,
];

export const DEBTOR_BASIC_INFO_LABELS = [
  "US.COLLECTION.COMMON:COMMON.NAME",
  "US.COLLECTION.COMMON:COMMON.NIN",
  "US.COLLECTION.COMMON:COMMON.TYPE",
  "US.COLLECTION.COMMON:COMMON.GENDER",
  "US.COLLECTION.COMMON:COMMON.BIRTHDATE",
  "US.COLLECTION.COMMON:COMMON.EMAIL",
  "US.COLLECTION.COMMON:COMMON.SMS",
  "US.COLLECTION.COMMON:COMMON.MOBILE",
  "US.COLLECTION.COMMON:COMMON.TELEPHONE",
  "US.COLLECTION.COMMON:COMMON.WORK",
];

export const DEBTOR_ADDRESS_INFO_LABELS = [
  "US.COLLECTION.COMMON:COMMON.COUNTRY",
  "US.COLLECTION.COMMON:COMMON.POSTAL_CODE",
  "US.COLLECTION.COMMON:COMMON.POSTAL_AREA",
  "US.COLLECTION.COMMON:COMMON.MUNICIPALITY_CODE",
  "US.COLLECTION.COMMON:COMMON.MUNICIPALITY_NAME",
  "US.COLLECTION.COMMON:COMMON.ADDRESS1",
  "US.COLLECTION.COMMON:COMMON.ADDRESS2",
  "US.COLLECTION.COMMON:COMMON.ADDRESS3",
];
